export interface FeatureFlag {
  enabled: boolean;
}

export interface FeatureFlags {
  partnerLock?: FeatureFlag;
  pcmReporting?: FeatureFlag;
  profilingWizardBrChanges?: FeatureFlag;
  riskConsiderations?: FeatureFlag;
  openTaskCheck?: FeatureFlag;
  contactNote?: FeatureFlag;
  clientReview?: FeatureFlag;
  brDeliveryInstructions?: FeatureFlag;
  zfBrCoreDataIntermediary?: FeatureFlag;
  zfBrRelationsIntermediary?: FeatureFlag;
  zfServicingUsersIntermediary?: FeatureFlag;
  zfBrPurposeIntermediary?: FeatureFlag;
  rocEnabled?: FeatureFlag;
  sanctionsInfo?: FeatureFlag;
  partnersNew?: FeatureFlag;
  showInstructions?: FeatureFlag;
  brom?: FeatureFlag;
  pcoWizardWC?: FeatureFlag;
  pcoPortfolio?: FeatureFlag;
}

export const defaultFeatureFlags = {
  partnerLock: {
    enabled: false,
  },
  pcmReporting: {
    enabled: false,
  },
  profilingWizardBrChanges: {
    enabled: false,
  },
  riskConsiderations: {
    enabled: false,
  },
  contactNote: {
    enabled: false,
  },
  clientReview: {
    enabled: false,
  },
  brDeliveryInstructions: {
    enabled: false,
  },
  zfBrCoreDataIntermediary: {
    enabled: false,
  },
  zfBrRelationsIntermediary: {
    enabled: false,
  },
  zfServicingUsersIntermediary: {
    enabled: false,
  },
  zfBrPurposeIntermediary: {
    enabled: false,
  },
  rocEnabled: {
    enabled: false,
  },
  sanctionsInfo: {
    enabled: false,
  },
  partnersNew: {
    enabled: false,
  },
  brom: {
    enabled: false,
  },
  pcoWizardWC: {
    enabled: false,
  },
  pcoPortfolio: {
    enabled: false,
  },
} as const;
